import React, { useState } from 'react';
import { useAdmin } from '@lok/context/AdminContext';
import useAuth from '../../hooks/useAuth';
import LogoUploadModal from './LogoUploadModal';

const EditableLogo = ({ university, children }) => {
  const { isAdminView } = useAdmin();
  const { getUser } = useAuth();
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // If not in admin view or no university/university.id, just return children
  if (!isAdminView || !university?.id) return children;

  return (
    <div
      className='relative'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}

      {/* Hover overlay — uses JS state to avoid conflicting with outer hover effects */}
      {isHovered && (
        <div
          role='button'
          tabIndex={0}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsModalOpen(true);
          }}
          className='absolute inset-0 bg-black/40 rounded-lg flex items-center justify-center cursor-pointer z-10'
        >
          <div className='bg-white dark:bg-[#1D2838] px-2.5 py-1 rounded-md shadow-md border border-gray-100 dark:border-gray-700'>
            <p className='text-xs font-semibold text-[#1C252E] dark:text-white flex items-center gap-1.5'>
              Upload logo
            </p>
          </div>
        </div>
      )}

      {/* Upload modal */}
      {isModalOpen && (
        <LogoUploadModal
          university={university}
          currentLogo={university?.logo}
          currentLogoDark={university?.logo_theme_dark}
          onClose={() => setIsModalOpen(false)}
          onSuccess={getUser}
        />
      )}
    </div>
  );
};

export default EditableLogo;
